<template>
  <div id="qualified-rate-gauge" style="height: 180px"></div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {
      option: {
        grid: {
          top: 0,
          bottom: 0,
        },
        series: [
          {
            type: 'gauge',
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 12,
            radius: '85%',
            center: ['50%', '45%'],
            data: [
              {
                name: 'itemA',
                value: 98.3,
                gradient: ['#03fd92', '#1ee5a3', '#2fd6ae'],
              },
            ],
            axisLabel: { show: false },
            axisTick: { show: false },
            pointer: { show: false },
            details: {
              show: true,
              formatter: '合格率\n{value}%',
              valueToFixed: 1,
              style: {
                fill: '#1ed3e5',
                fontSize: 14,
              },
            },
          },
        ],
      },
    }
  },
  mounted() {
    const container = document.getElementById('qualified-rate-gauge')
    const myChart = new Charts(container)
    myChart.setOption(this.option)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/quality-zone/qualified-rate-gauge.vue